import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './AvailabilityMonth.module.scss';

const UNAVAILABLE = 'red';
const AVAILABLE = 'green';
const NOT_DEFINED = 'grey';

const InternalDivFactory =
  (daysInMonth, month, year) => (start, end, color) => {
    const endTemp = end === -1 ? daysInMonth : end;
    const width = ((endTemp - start) / daysInMonth) * 100;
    const left = Math.max((start * 100) / daysInMonth, 0);
    const className = classNames(styles['availability-month__interval'], {
      [styles[`availability-month__interval--${color}`]]: color
    });

    return (
      <div
        key={`${year}-${month}-${start}-${end}`}
        style={{ width: `${width}%`, left: `${left}%` }}
        className={className}
      />
    );
  };

const AvailabilityMonth = ({
  monthLabel,
  price = null,
  currency = null,
  daysToNow,
  daysInMonth,
  occupanciesByDate = [],
  month,
  year
}) => {
  let lastEnd = 0;
  const content = [];
  const generateIntervalDiv = InternalDivFactory(daysInMonth, month, year);

  let greyFont = false;
  if (daysToNow > 0) {
    lastEnd = daysToNow >= daysInMonth ? -1 : daysToNow;
    content.push(generateIntervalDiv(0, lastEnd, NOT_DEFINED));
    greyFont = true;
  }

  if (lastEnd !== -1) {
    const sortedOccupancies = occupanciesByDate.slice(0);
    sortedOccupancies.sort((a, b) => a.from - b.from);

    sortedOccupancies.forEach(occupancy => {
      if (occupancy.from > lastEnd + 1) {
        content.push(generateIntervalDiv(lastEnd, occupancy.from, AVAILABLE));
        lastEnd = occupancy.from;
      }

      content.push(generateIntervalDiv(lastEnd, occupancy.to, UNAVAILABLE));
      lastEnd = occupancy.to;
    });

    if (lastEnd !== -1) {
      content.push(generateIntervalDiv(lastEnd, -1, AVAILABLE));
    }
    greyFont = false;
  }

  return (
    <div className={styles['availability-month']}>
      <span
        className={classNames([
          styles['availability-month__title'],
          styles[`${greyFont ? 'availability-month__title--grey' : ''}`]
        ])}
      >
        {monthLabel}
        {price && (
          <span className={styles['availability-month__price']}>
            {price}
            {currency}
          </span>
        )}
      </span>
      <div className={styles['availability-month__content']}>{content}</div>
    </div>
  );
};

AvailabilityMonth.propTypes = {
  occupanciesByDate: PropTypes.arrayOf(PropTypes.object),
  year: PropTypes.number.isRequired,
  month: PropTypes.number.isRequired,
  daysInMonth: PropTypes.number.isRequired,
  monthLabel: PropTypes.string.isRequired,
  daysToNow: PropTypes.number.isRequired,
  price: PropTypes.number,
  currency: PropTypes.string
};

export default AvailabilityMonth;
